import { render } from "./TriviaCashPayment.vue?vue&type=template&id=23c9a8b6&scoped=true"
import script from "./TriviaCashPayment.vue?vue&type=script&lang=js"
export * from "./TriviaCashPayment.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=23c9a8b6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c9a8b6"]])

export default __exports__